import React,{useEffect} from 'react'
import styles from './GeoHeader.module.scss'
import Content from '../../../components/ContentPharma'
import Layout from '../../../components/Layout'
import Header from './Header'
import Gender from '../../GenderAge'
import SeasonalPattern from '../../SeasonalPattern'
//import SystemNotification from './../../Dashboard/SystemNotification'
import { useParams } from 'react-router-dom'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import { startDate, endDate, displayDate,actualsStartDate,forecastsStartDate } from '../dates'
import dataDisplayOptions from '../FluTabs/FluMap/dataDisplayOptions'


const FluGeoDashboard = () => {
  const { geo_parent, area, loc } = useParams()
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected ='MSA'
            >
              {/* <SystemNotification/> */}
              <Header headerType={geo_parent} headerNumber={3} geo_id={loc} />

              <DashboardMap
                geo_type={area}
                geo_parent={geo_parent}
                zoomLocation={loc}
              />
              <Gender geo_type={area} geo_id={loc} data_type="FLU"/>
              <SeasonalPattern geo_type={area} geo_id={loc} data_type="FLU"/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default FluGeoDashboard
